// extracted by mini-css-extract-plugin
export var menuItem = "rUYSqi9OL8DODJfMWd1l";
export var menuItem_active = "PaJZLgptAlV4m3Fdjq4j";
export var menuItem_badge = "ykPLbOH5UNZJH4jObXke";
export var menuItem_icon = "e7YkGoq2RdotCWOmHHit";
export var menuSection = "uX34tLLWfaZ8JvkHNwXe";
export var menuSection_list = "barr2509NeMg37cIMZCF";
export var menuSection_title = "A3SX125SZWK03pLApGIz";